import { createWebHistory, createRouter } from "vue-router";
import Home from "./views/home/Home.vue";
// import Register from "./views/register/Register.vue";
// import RegisterIndex from "./views/register/RegisterIndex.vue";
import RegisterRecrut from "./views/register/RegisterRecrut.vue";
import RegisterPrest from "./views/register/RegisterPrest.vue";
import Login from "./views/login/Login.vue";
import Forgot_password from "./views/login/Forgot_password.vue";
import Service from "./views/nosservices/Service.vue";
import Cat_service from "./views/nosservices/Cat_service.vue";
import Detail_service from "./views/nosservices/Detail_service.vue";
import Detail_acteur from "./views/home/Detail_acteur.vue";
import Delete_account from "./views/home/Delete_account.vue";
import Dashboard from "./views/auth/Dashboard.vue";
import User_profil from "./views/auth/User_profil.vue";
import User_services from "./views/auth/User_services.vue";
import About from "./views/quicklinks/About.vue";
import condition from "./views/quicklinks/condition.vue";
import contact from "./views/quicklinks/contact.vue";
import CreateCompte from "./views/register/CreateCompte.vue";


const routes = [{
        path: "/",
        name: "home",
        component: Home,
        meta: { title: 'Accueil' }
    },

    {
        path: "/resultats",
        name: "SearchResult",
        component: () => import("@/views/home/SearchResult.vue"),
    },
    {
        path: "/a-propos-de-nous",
        name: "about",
        component: About,
        meta: { title: 'A propos de nous' }
    },
    {
        path: "/contactez-nous",
        name: "contact",
        component: contact,
        meta: { title: 'Nous contacter' }
    },
    {
        path: "/nos-conditions-generales",
        name: "condition",
        component: condition,
        meta: { title: 'Condition Générale' }
    },
    {
        path: "/details/:prestataireId/metier/:metierId",
        name: "detailActeur",
        component: Detail_acteur,
        meta: { title: 'Détail du prestataire', authRequired: 'true' }
    },
    {
        path: "/supprimer-mon-compte",
        name: "deleteAccount",
        component: Delete_account,
        meta: { title: 'Supprimer mon compte'}
    },
    {
        path: "/nos-services",
        name: "service",
        component: Service,
        meta: { title: 'Nos services' }
    },
    {
        path: "/detail-du-service/:categorieId/:categorieName",
        name: "detailService",
        component: Detail_service,
        meta: { title: 'Détails de nos services' }
    },
    {
        path: "/categorie-du-service/:subcatId/:subcatName",
        name: "categorieService",
        component: Cat_service,
        meta: { title: 'Les catégories de nos services' }
    },

    {
        path: "/creation-de-compte-recruteur",
        name: "create-de-compteR",
        component: RegisterRecrut,
        meta: { title: 'Inscription des Recruteurs' }
    },

       {
        path: "/creation-de-compte-prestataire",
        name: "create-de-compte",
        component: RegisterPrest,
        meta: { title: 'Inscription des prestataire' }
    },
     {
        path: "/page-creation",
        name: "page-creation",
        component: CreateCompte,
        meta: { title: 'Redirection inscription' }
    },
    {
        path: "/connexion",
        name: "Login",
        component: Login,
        meta: { title: 'Connexion' }
    },
    {
        path: "/reinitialisation-de-mot-de-passe",
        name: "Forgot_password",
        component: Forgot_password,
        meta: { title: 'Réinitialisation de mot de passe' }
    },
    {
        path: "/dashboard-espace-utilisateur",
        name: "dashboard",
        component: Dashboard,
        meta: { title: 'Dashboard utilisateur', authRequired: 'true' }
    },
    {
        path: "/mes-services",
        name: "User_services",
        component: User_services,
        meta: { title: 'Mes Services', authRequired: 'true' }
    },
    {
        path: "/mon-profil",
        name: "User_profil",
        component: User_profil,
        meta: { title: 'Mon profil', authRequired: 'true' }
    },
];




const router = createRouter({
    history: createWebHistory(),
    //mode: 'hash',
    routes,
    scrollBehavior() {
    return { top: 0 };
    },
});

router.afterEach((to, from, next) => {
    document.title = to.meta.title + ' | YaJobIci'

    if (to.name === 'Login' && localStorage.getItem("authUser")) {
        router.push({
            name: 'dashboard'
        })
    } else if (to.meta.authRequired && !localStorage.getItem("authUser")) {
        router.push({
            name: 'Login',
            query: {
                to: to.name
            }
        })
    }

    return next()
});

export default router;
